import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import {
  getRiverrAdsPixelId,
  shouldLoadRiverrAdsPixel,
} from "../../helpers/riverrAdsTracking";

const PIXEL_SCRIPT_ID = "riverr-ads-meta-pixel";

const injectPixel = (pixelId) => {
  if (typeof window === "undefined" || !pixelId) return;
  if (window.fbq) {
    window.fbq("init", pixelId);
    window.fbq("track", "PageView");
    return;
  }
  if (document.getElementById(PIXEL_SCRIPT_ID)) return;

  /* eslint-disable */
  !(function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = !0;
    n.version = "2.0";
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    t.id = PIXEL_SCRIPT_ID;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
  /* eslint-enable */
  window.fbq("init", pixelId);
  window.fbq("track", "PageView");
};

/**
 * Loads Riverr's ads pixel on founder signup + admin hosts only.
 * Merchant storefronts keep their own pixel in ecommerce_store.
 */
const RiverrAdsPixel = () => {
  const location = useLocation();
  const hasMountedRef = useRef(false);
  const pixelId = getRiverrAdsPixelId();

  useEffect(() => {
    if (!shouldLoadRiverrAdsPixel() || !pixelId) return;
    injectPixel(pixelId);
  }, [pixelId]);

  useEffect(() => {
    if (!hasMountedRef.current) {
      hasMountedRef.current = true;
      return;
    }
    if (!shouldLoadRiverrAdsPixel() || !window.fbq) return;
    window.fbq("track", "PageView");
  }, [location.pathname, location.search]);

  return null;
};

export default RiverrAdsPixel;
